__turbopack_context__.v({
  "responsive-image": "video-content-module-scss-module__fI1wfa__responsive-image",
  "video-content": "video-content-module-scss-module__fI1wfa__video-content",
});
